import { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import $ from "jquery";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import api from "../../utils/axios";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";

import { showLoader, hideLoader, showAlert, isEmpty, isSingleSelect, showContaimerLoader, isPhone, isEmail, removeChar, hasPermission } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
const module = "user";
const modulePath = "/users";
const moduleName = "User";
const moduleID = 29;
class Form extends Component {
  constructor(props) {
    super(props);
    const editID = this.props.location.state?.editID ?? "";
    this.state = {
      editID,
      postdata: {
        firstName: "",
        userName: "",
        userPassword: "",
        usercPassword: "",
        userEmail: "",
        userPhone: "",
        userStatus: "",
        userRoleID: "",
      },
      detaildata: [],
      roleList: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    if (this.state.editID !== "") {
      if (!hasPermission(moduleID, "edit")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
      const params = {
        params: "",
        url: `${module}/detail/${this.state.editID}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    } else {
      if (!hasPermission(moduleID, "add")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
    }
    this.loadDropdown();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.detaildata !== nextProps.detaildata && nextProps.detaildata !== "" && this.state.editID !== "") {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          const result = nextProps.detaildata[0].result;

          const userStatus = result.userStatus === "A" ? "Active" : "In Active";
          const status =
            result.userStatus !== "" && result.userStatus !== null
              ? {
                  label: userStatus,
                  value: result.userStatus,
                }
              : "";
          const clientupdatedata = {
            firstName: result.firstName,
            userName: result.userName,
            userPassword: "",
            usercPassword: "",
            userEmail: result.userEmail,
            userPhone: result.userPhone,
            userRoleID: result.userRoleID,
            userStatus: status,
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }
  loadDropdown() {
    api
      .get("userrole/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ roleList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: removeChar(value) } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    const postData = this.state.postdata;

    const postObject = {
      firstName: postData.firstName,
      userName: postData.userName,
      userPassword: postData.userPassword,
      userEmail: postData.userEmail,
      userPhone: postData.userPhone,
      userStatus: postData.userStatus?.value ?? "I",
      userRoleID: postData.userRoleID?.value ?? "",
    };

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, method);
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage={module} {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid  mx-3">
                  <div className="page-header">
                    <h1 className="page-title">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={modulePath}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            roleList={this.state.roleList}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop: $(document).find("#modulefrm .error:first").offset().top - 100,
                                    },
                                    500,
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);
const areSame = (password, rePassword) => (password === rePassword ? null : "Password do not match.");
export const isEmptyPassword = function (value, editID) {
  if (editID !== "") {
    return null;
  } else {
    return value === "" ? "This field is required." : null;
  }
};
export const isEmptyCPassword = function (value, userPassword, editID) {
  if (editID !== "" && userPassword === "") {
    return null;
  } else {
    return value === "" ? "This field is required." : null;
  }
};

function validationConfig(props) {
  const { firstName, userName, userPassword, usercPassword, userRoleID, userEmail, userPhone, userStatus } = props.fields;

  return {
    fields: ["firstName", "userName", "userPassword", "usercPassword", "userRoleID", "userEmail", "userPhone", "userStatus"],
    validations: {
      firstName: [[isEmpty, firstName]],
      userName: [[isEmpty, userName]],
      userPassword: [[isEmptyPassword, userPassword, props.editID]],
      usercPassword: {
        rules: [
          [isEmptyCPassword, usercPassword, userPassword, props.editID],
          [areSame, userPassword, usercPassword],
        ],
        fields: ["userPassword", "usercPassword"],
      },
      userRoleID: [[isSingleSelect, userRoleID]],
      userEmail: [
        [isEmpty, userEmail],
        [isEmail, userEmail],
      ],
      userPhone: [
        [isEmpty, userPhone],
        [isPhone, userPhone],
      ],
      userStatus: [[isSingleSelect, userStatus]],
    },
  };
}

class PostForm extends Component {
  goBack() {
    this.props.history.push(modulePath);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handlecheckedChange(name, e) {
    this.props.onChange(name, e.target.checked);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgfirstName,
      errMsguserName,
      errMsguserPassword,
      errMsgusercPassword,
      errMsguserEmail,
      errMsguserPhone,
      errMsgStatus,
      errMsguserRoleID = "";
    if ($validation.firstName.error.reason !== undefined) {
      errMsgfirstName = $validation.firstName.show && <span className="error">{$validation.firstName.error.reason}</span>;
    }
    if ($validation.userName.error.reason !== undefined) {
      errMsguserName = $validation.userName.show && <span className="error">{$validation.userName.error.reason}</span>;
    }
    if ($validation.userPassword.error.reason !== undefined) {
      errMsguserPassword = $validation.userPassword.show && <span className="error">{$validation.userPassword.error.reason}</span>;
    }
    if ($validation.usercPassword.error.reason !== undefined) {
      errMsgusercPassword = $validation.usercPassword.show && <span className="error">{$validation.usercPassword.error.reason}</span>;
    }
    if ($validation.userEmail.error.reason !== undefined) {
      errMsguserEmail = $validation.userEmail.show && <span className="error">{$validation.userEmail.error.reason}</span>;
    }
    if ($validation.userPhone.error.reason !== undefined) {
      errMsguserPhone = $validation.userPhone.show && <span className="error">{$validation.userPhone.error.reason}</span>;
    }
    if ($validation.userStatus.error.reason !== undefined) {
      errMsgStatus = $validation.userStatus.show && <span className="error">{$validation.userStatus.error.reason}</span>;
    }
    if ($validation.userRoleID.error.reason !== undefined) {
      errMsguserRoleID = $validation.userRoleID.show && <span className="error">{$validation.userRoleID.error.reason}</span>;
    }

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-3">
              <label className="form-label">
                Name<span className="lbl-error">*</span>
              </label>
              <input type="text" className="form-control" placeholder="Name" name="firstName" value={fields.firstName} {...$field("firstName", (e) => onChange("firstName", e.target.value))} />
              {errMsgfirstName}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                User Name<span className="lbl-error">*</span>
              </label>
              <input type="text" className="form-control" placeholder="User Name" name="userName" value={fields.userName} {...$field("userName", (e) => onChange("userName", e.target.value))} />
              {errMsguserName}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Password{this.props.editID === "" && <span className="lbl-error">*</span>}</label>
              <div className="validate-input input-group" id="Password-toggle">
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                  className="input-group-text bg-white text-muted"
                >
                  <i className="zmdi zmdi-eye text-muted" aria-hidden="true"></i>
                </a>
                <input
                  className="input100 border-start-0 form-control ms-0"
                  type="password"
                  placeholder="Password"
                  value={fields.userPassword}
                  tabIndex={2}
                  {...$field("userPassword", (e) => onChange("userPassword", e.target.value))}
                />
                {errMsguserPassword}
              </div>
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Confirm Password{this.props.editID === "" && <span className="lbl-error">*</span>}</label>
              <div className="validate-input input-group" id="Password-toggle1">
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                  className="input-group-text bg-white text-muted"
                >
                  <i className="zmdi zmdi-eye text-muted" aria-hidden="true"></i>
                </a>
                <input
                  className="input100 border-start-0 form-control ms-0"
                  type="password"
                  placeholder="Confirm Password"
                  value={fields.usercPassword}
                  tabIndex={2}
                  {...$field("usercPassword", (e) => onChange("usercPassword", e.target.value))}
                />
                {errMsgusercPassword}
              </div>
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                User Role<span className="lbl-error">*</span>
              </label>
              <Select value={fields.userRoleID} onChange={this.handleSelectChange.bind(this, "userRoleID")} placeholder="Select User Role" isClearable={true} options={this.props.roleList} />
              {errMsguserRoleID}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Email<span className="lbl-error">*</span>
              </label>
              <input type="text" className="form-control" placeholder="Address" name="userEmail" value={fields.userEmail} {...$field("userEmail", (e) => onChange("userEmail", e.target.value))} />
              {errMsguserEmail}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Phone Number<span className="lbl-error">*</span>
              </label>
              <input type="text" className="form-control" placeholder="Phone Number" name="userPhone" value={fields.userPhone} {...$field("userPhone", (e) => onChange("userPhone", e.target.value))} />
              {errMsguserPhone}
            </div>

            <div className="form-group col-md-3">
              <label className="form-label">
                Status<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.userStatus}
                onChange={this.handleSelectChange.bind(this, "userStatus")}
                placeholder="Select Status"
                isClearable={true}
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "In Active" },
                ]}
              />
              {errMsgStatus}
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div className="btn-group me-2 sw-btn-group-extra submit_frm" role="group">
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                {this.props.editID !== "" ? "Update" : "Add New"}
              </button>

              <button className="btn btn-secondary" onClick={this.goBack.bind(this)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
